export default __webpack_public_path__ + "static/logo-b3541bb098ddbafd186447e8ad418cfa.svg";